import React from 'react';
import { Box, keyframes, useTheme } from '@mui/material';

const gradientAnimation = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

interface AnimatedGradientProps {
  colors?: string[];
  duration?: number;
  opacity?: number;
}

const AnimatedGradient: React.FC<AnimatedGradientProps> = ({
  colors: providedColors,
  duration = 15,
  opacity = 0.15,
}) => {
  const theme = useTheme();
  const colors = providedColors ?? [theme.palette.primary.main, theme.palette.secondary.main, theme.palette.primary.main];

  return (
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        background: `linear-gradient(135deg, ${colors.join(', ')})`,
        backgroundSize: '200% 200%',
        animation: `${gradientAnimation} ${duration}s ease infinite`,
        '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
        opacity,
        pointerEvents: 'none',
        zIndex: 0,
      }}
    />
  );
};

export default AnimatedGradient;
